module.exports = __webpack_public_path__ + "static/media/connected.9c69aada.wav";